import { ax } from 'src/client'
import { removeFalsyProperties } from 'src/utils'
import {
  CANCEL_INVOICE,
  COMMENT_INVOICE,
  EXPORT_INVOICE_LIST,
  FAST_SELL_INVOICES,
  FIND_CASES,
  GET_INVOICE_LIST,
  GET_INVOICE_PRICING,
  GET_INVOICE_TIMELINE,
  PUBLISH_INVOICE,
  REJECT_INVOICE,
  SALE_CHECK_INVOICE,
  SELL_INVOICE,
  WRITEOFF_INVOICE
} from './serviceURLS'

function getParamsToSend(params) {
  return removeFalsyProperties({
    limit: params.limit,
    offset: params.offset,
    descending: params.descending,
    sort_by: params.sortBy,
    state: params.state,
    number: params.invoiceNumber,
    payment_reference_number: params.referenceNumber,
    customer_country: params.customerCountry,
    customer_id: params.customerId,
    customer_rating: params.customerRating,
    counterparty_country: params.counterpartyCountry,
    counterparty_vat_number: params.counterpartyVatNumber,
    counterparty_rating: params.counterpartyRating,
    partner_id: params.partnerId,
    amount_from: params.amountFrom,
    amount_to: params.amountTo,
    currency: params.currency,
    created_at_from: params.createdAtFrom,
    created_at_to: params.createdAtTo,
    credit_note_matched: params.creditNoteMatched,
    sale_state: params.saleState
  })
}

export function getInvoices(params) {
  return ax.get(GET_INVOICE_LIST, {
    params: getParamsToSend(params)
  })
}

export function rejectInvoice({ invoiceId, reason }) {
  return new Promise((resolve, reject) => {
    ax.put(REJECT_INVOICE.replace(':invoice_id', invoiceId), {
      reject_reason: reason
    })
      .then((val) => {
        resolve(val)
      })
      .catch((err) => {
        err.invoiceId = invoiceId
        reject(err)
      })
  })
}

export function commentInvoice({ invoiceId, message }) {
  return ax.post(COMMENT_INVOICE.replace(':invoice_id', invoiceId), {
    type: 'INVOICE_COMMENTED',
    message,
    invoice_id: invoiceId
  })
}

export async function rejectInvoiceWithComment({ invoiceId, reason, message }) {
  try {
    await rejectInvoice({ invoiceId, reason })

    return commentInvoice({ invoiceId, message })
  } catch (err) {
    err.invoiceId = invoiceId

    return Promise.reject(err)
  }
}

export function getInvoicePricing(invoiceId, payload) {
  const params = payload
    ? {
        investor_discount: payload.investorDiscount,
        debt_collection: payload.debtCollection
      }
    : {}

  return ax.get(GET_INVOICE_PRICING.replace(':invoice_id', invoiceId), {
    params
  })
}

export function sellInvoice(invoiceId) {
  return ax.put(SELL_INVOICE.replace(':invoice_id', invoiceId))
}

export function publishInvoice(invoiceId, payload) {
  return ax.put(PUBLISH_INVOICE.replace(':invoice_id', invoiceId), {
    account_id: payload.accountId,
    amount: payload.amount,
    size: payload.size,
    isin: payload.isin,
    type: payload.type,
    user_id: payload.userId
  })
}

export function fastSellInvoices(invoiceIds) {
  return ax.put(FAST_SELL_INVOICES, {
    invoice_ids: invoiceIds
  })
}

export function cancelInvoice(invoiceId) {
  return ax.put(CANCEL_INVOICE.replace(':invoice_id', invoiceId))
}

export function writeOffInvoice(invoiceId) {
  return ax.put(WRITEOFF_INVOICE.replace(':invoice_id', invoiceId))
}

export function exportInvoices({ invoiceIds, params }) {
  return ax.put(
    EXPORT_INVOICE_LIST,
    { invoice_ids: invoiceIds },
    { params: getParamsToSend(params) }
  )
}

export function recheckInvoice(invoiceId) {
  return ax.put(SALE_CHECK_INVOICE.replace(':invoice_id', invoiceId))
}

export function getInvoiceTimeline(invoiceId) {
  return ax.get(GET_INVOICE_TIMELINE.replace(':invoice_id', invoiceId))
}

export function findCases(params) {
  return ax.get(FIND_CASES, { params })
}
